export default __webpack_public_path__ + "static/media/avatar.49c9fa14.svg";